import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const orderInProgressIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.85909 18.5C9.61647 20.1961 8.15777 21.5 6.39453 21.5C4.63129 21.5 3.17259 20.1961 2.92997 18.5H1.89453V6.5C1.89453 5.94772 2.34225 5.5 2.89453 5.5H16.8945C17.4468 5.5 17.8945 5.94772 17.8945 6.5V8.5H20.8945L23.8945 12.5557V18.5H21.8591C21.6164 20.1961 20.1577 21.5 18.3945 21.5C16.6313 21.5 15.1726 20.1961 14.9299 18.5H9.85909ZM15.8945 7.5H3.89453V15.5505C4.52979 14.9022 5.41519 14.5 6.39453 14.5C7.79073 14.5 8.99598 15.3175 9.55771 16.5H15.2313C15.399 16.147 15.6241 15.8264 15.8945 15.5505V7.5ZM17.8945 13.5H21.8945V13.215L19.8862 10.5H17.8945V13.5ZM18.3945 19.5C19.0476 19.5 19.6032 19.0826 19.8091 18.5C19.8644 18.3436 19.8945 18.1753 19.8945 18C19.8945 17.1716 19.2229 16.5 18.3945 16.5C17.5661 16.5 16.8945 17.1716 16.8945 18C16.8945 18.1753 16.9246 18.3436 16.9799 18.5C17.1858 19.0826 17.7414 19.5 18.3945 19.5ZM7.89453 18C7.89453 17.1716 7.22296 16.5 6.39453 16.5C5.5661 16.5 4.89453 17.1716 4.89453 18C4.89453 18.1753 4.92461 18.3436 4.97988 18.5C5.1858 19.0826 5.74142 19.5 6.39453 19.5C7.04764 19.5 7.60326 19.0826 7.80918 18.5C7.86445 18.3436 7.89453 18.1753 7.89453 18Z"
      fill="#F26533"
    />
  </svg>
);

export const OrderInProgressIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={orderInProgressIcon} {...props} />;
